<template>
    <div class="machine-learning-preview">
        <p class="machine-learning-preview__header">
            <span
                class="label-block"
                :class="{'tree-view--padding': !isCollidable}"
            >
                <span
                  v-if="isCollidable"
                  @click.prevent="toggleBody"
                  :class="{ 'right': !isOpened }"
                >
                  <or-icon icon="keyboard_arrow_down" />
                </span>

                <span
                    class="label"
                    :class="{ 'entity-head--name': isHeadNode, clickable: isClickable }"
                    @click="onClick"
                >
                    {{collapsibleLabel}}
                </span>
            </span>

            <entity-type-label
                v-if="isHeadNode"
                :entity-type="entity.type"
            />
        </p>

        <div
            v-if="isOpened"
            class="machine-learning-preview__body"
        >
            <div
                v-for="(feature, index) in entityFeatures"
                :key="index"
                class="ml-feature--preview label-block tree-view--padding"
            >
                <div class="label">
                    {{ feature.modelName || feature.featureName || '' }}
                </div>
                <entity-type-label :entity-type="getFeatureType(feature)"/>
            </div>
            <div
                v-for="(child, index) in entityChildren"
                :key="`${child.name}-${index}`"
            >
                <machine-learning-preview
                    :entity="child"
                />
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import EntityTypeLabel from '@/components/model/common/EntityTypeLabel'
import { getEntityTypeLabel } from '../nlu-model/sidebar/entities/entity-types'

export default {
  name: 'machine-learning-preview',
  components: {
    EntityTypeLabel
  },
  props: {
    entity: {
      type: Object,
      default: () => ({})
    },
    isClickable: Boolean,
    isHeadNode: Boolean
  },

  computed: {
    ...mapState('knowledgebase/entities', ['allEntities']),

    typeIconText () {
      return getEntityTypeLabel(this.$props.entity.type)
    },

    collapsibleLabel () {
      return this.entity.name
    },

    entityFeatures () {
      return this.entity.features || []
    },

    entityChildren () {
      return this.entity.children || []
    },

    isCollidable () {
      return this.entityChildren.length !== 0 || this.entityFeatures.length !== 0
    }
  },

  data () {
    return {
      isOpened: false
    }
  },

  methods: {
    getFeatureType (feature) {
      const entity = this.allEntities.value.find(entity => entity.name === feature.modelName || entity.name === feature.featureName)
      return entity ? entity.type : ''
    },

    toggleBody () {
      if (this.isCollidable) {
        this.isOpened = !this.isOpened
      }
    },

    onClick () {
      this.$emit('click')
    }
  }
}
</script>

<style lang="scss" scoped>
    .machine-learning-preview {
        .tree-view--padding {
            // Width of the Toggle icon
            margin-left: 28px;
        }
        &__header {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
        }

        &__body {
            border-left: solid 1px $or-grey;
            margin-bottom: $sp-3;
            margin-left: $sp-5;
            padding-left: $sp-2;

            .ml-feature--preview:not(:first-child) {
                margin: 16px 0 0;
            }
        }

        .label-block {
            display: flex;
            align-items: center;
            justify-content: space-between;

            .material-icons {
                font-size: 20px;
                margin-right: $sp-2;
                font-weight: bold;
                transition: all .2s ease;
                user-select: none;
                cursor: pointer;
                &.right {
                    transform: rotate(-90deg);
                }
                &:hover {
                    color: $or-blue;
                    cursor: pointer;
                    transition: all .2s ease;
                }
            }

            .label {
                font-size: 14px;
                font-weight: 600;
                color: $or-black-blue;
            }

            .entity-head--name {
                font-size: 14px;
                font-weight: 600;
                color: $or-black-blue;
            }
            .clickable {
                &:hover {
                    color: $or-blue;
                    cursor: pointer;
                    transition: all .2s ease;
                }
            }
        }

    }
</style>
